// extracted by mini-css-extract-plugin
export default {"container":"OurCustomers_container__0FNi3","box":"OurCustomers_box__+CY4q","icon":"OurCustomers_icon__HyVvF"};